// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('OpeningStock/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('OpeningStock/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/OpeningStock/List', { params })
  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: response.data,
  }
})

export const OpeningStockSlice = createSlice({
  name: 'OpeningStock',
  initialState: {
    vendorInvoice: {},
    data: [],
    totalRecords: 1,
    params: {},
    loadingState: { getData: false}
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        // console.log(state, action)
        state.data = action.payload.data.data.list
        state.totalRecords = action.payload.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default OpeningStockSlice.reducer
